import { useState, useEffect } from "react";

export default function useOnScreen(ref: any, rootMargin: number = 0) {
	// State and setter for storing whether element is visible
	const [isIntersecting, setIntersecting] = useState(false);

	useEffect(() => {
		if (ref) {
			const observer = new IntersectionObserver(
				([entry]) => {
					// Update our state when observer callback fires
					setIntersecting(entry.isIntersecting);
				},
				{
					rootMargin: `${rootMargin}px`,
				}
			);
			const current = ref?.current;
			if (current) {
				observer.observe(current);
			}
			return () => {
				observer.unobserve(current);
			};
		}
	}, [ref, rootMargin]); // Empty array ensures that effect is only run on mount and unmount

	return isIntersecting;
}
